import { Workbook } from 'exceljs';
import * as momentNs from 'moment-timezone';
import * as objectPath from 'object-path';

import { FieldConfig, FieldType } from '@ideapa/common-interfaces';
import {
  currencyFormatter,
  currencyPrecision,
  decimalFormatter,
  integerFormatter,
  percentFormatter,
  percentPrecision,
} from '..';

export async function createExcel<T>(
  data: T[],
  fileName: string,
  columns: FieldConfig[],
  beforeAddWorksheet?: (workbook: Workbook) => void,
  afterAddWorksheet?: (workbook: Workbook) => void
): Promise<ArrayBuffer> {
  const workbook = new Workbook(); // Create a new workbook
  if (beforeAddWorksheet) {
    beforeAddWorksheet(workbook);
  }
  addWorkbook(workbook, data, fileName, columns);
  if (afterAddWorksheet) {
    afterAddWorksheet(workbook);
  }
  return workbook.xlsx.writeBuffer();
}
export function addWorkbook<T>(
  workbook: Workbook,
  data: T[],
  fileName: string,
  columns: FieldConfig[]
) {
  const worksheet = workbook.addWorksheet(fileName); // New Worksheet

  const columnList = columns.map((c: FieldConfig) => {
    let style: any = undefined;
    if (c.type === FieldType.date) {
      style = { numFmt: 'dd/mm/yyyy' };
    }
    return {
      header: c.label,
      key: c.name,
      width: 20,
      style,
    };
  });

  worksheet.columns = columnList;
  // header column
  worksheet.getRow(1).eachCell((cell: any) => {
    cell.font = {
      bold: true,
    };
    cell.fill = {
      type: 'pattern',
      // pattern: 'gray0625',
      pattern: 'solid',
      fgColor: {
        argb: 'FFf3f3f3',
      },
      bgColor: {
        argb: 'FF000000',
      },
    };
  });

  // Looping through data

  data.forEach((item: T) => {
    const row: any = {};
    columns.map((cell: FieldConfig) => {
      row[cell.name] = getRowValue(row, item, cell);
    });
    // Add data in worksheet
    worksheet.addRow(row);
  });

  // add border in cells
  // NB: non lasciare celle vuote, altrimenti non mette il bordo
  worksheet.eachRow((row: any) => {
    row.eachCell((cell: any) => {
      cell.border = {
        top: { style: 'hair' },
        left: { style: 'hair' },
        bottom: { style: 'hair' },
        right: { style: 'hair' },
      };
    });
  });

  // salvo il file su server solo per verifica
  // workbook.xlsx.writeFile(`${this.excelPath}/${request.body.fileName}.xlsx`);
}

function getRowValue(row: any, item: any, cell: FieldConfig): any {
  let value = objectPath.get(item, cell.name);
  const moment = momentNs;
  // const integerFormatter = new Intl.NumberFormat('it-IT', {
  //   maximumFractionDigits: 0,
  // });
  // const decimalFormatter = new Intl.NumberFormat('it-IT', {
  //   style: 'decimal',
  //   minimumFractionDigits: 2,
  //   maximumFractionDigits: 2,
  // });
  // const percentFormatter = new Intl.NumberFormat('it-IT', {
  //   style: 'decimal',
  //   minimumFractionDigits: 2,
  //   maximumFractionDigits: 2,
  // });
  // const currencyFormatter = new Intl.NumberFormat('it-IT', {
  //   style: 'currency',
  //   currency: 'EUR',
  // });
  switch (cell.type) {
    case FieldType.date:
      value =
        value != null
          ? moment.tz(value, 'Europe/Rome').format('DD/MM/YYYY')
          : '';
      break;
    case FieldType.time:
      value =
        value != null ? moment.tz(value, 'Europe/Rome').format('HH:mm:ss') : '';
      break;
    case FieldType.datetime:
      value =
        value != null
          ? moment.tz(value, 'Europe/Rome').format('DD/MM/YYYY HH:mm:ss')
          : '';
      break;

    case FieldType.integer:
      value =
        value != undefined && value != null
          ? integerFormatter.format(value)
          : '';
      break;
    case FieldType.decimal:
      value =
        value != undefined && value != null
          ? decimalFormatter(currencyPrecision).format(value)
          : '';
      break;
    case FieldType.percent:
      value =
        value != undefined && value != null
          ? percentFormatter(percentPrecision).format(value) + '%'
          : '';
      break;
    case FieldType.currency:
      value = value != undefined ? currencyFormatter.format(value) : '';
      break;
    case FieldType.boolean:
      value = value == true ? 'Sì' : value == false ? 'No' : '';
      break;
    case FieldType.enum:
      value = cell.elementValues
        ? cell.elementValues.find((e) => e.value === value)?.description
        : value;
      break;
    case FieldType.json:
      value =
        value != null
          ? JSON.stringify(value)
              .replace('{', '')
              .replace('}', '')
              .split(',')
              .join('\n')
              .split(':')
              .join(': ')
              .split('\\')
              .join('')
              .split('"')
              .join('')
          : '';
      break;
    case FieldType.text:
    case FieldType.year:
      //case FieldType.integerNoThousandSeparator:
      break;
  }

  if (value == undefined) {
    value = '';
  }

  return value;
}
export function downloadXlsx(data: ArrayBuffer, fileName: string) {
  const blob = new Blob([data], {
    type: 'application/xlsx',
  });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${fileName}.xlsx`;
  document.body.appendChild(link);
  link.click();

  URL.revokeObjectURL(url);
}
